import { authExchange } from '@urql/exchange-auth'
import Debug from 'debug'
import { ReactNode, useEffect, useRef } from 'react'
import { Client, Provider, cacheExchange, fetchExchange } from 'urql'
import { useLocalStorage } from 'usehooks-ts'

const log = Debug('ela:UrqlProvider')
log.log = console.info.bind(console)

const TOKEN_STORAGE_KEY = 'token'
const getToken = () => {
  if (typeof window === 'undefined') {
    return
  }
  return localStorage.getItem(TOKEN_STORAGE_KEY)
}

const auth = authExchange(async (utilities) => {
  const token = getToken()
  return {
    addAuthToOperation(operation) {
      return token
        ? utilities.appendHeaders(operation, {
            Authorization: `Bearer ${token}`,
          })
        : operation
    },
    didAuthError(error) {
      return error.message.toLowerCase().includes('unauthorized')
      // return error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHORIZED')
    },
    refreshAuth() {
      // To do: implement refresh token logic
      localStorage.removeItem(TOKEN_STORAGE_KEY)
      window.location.href = '/'
      return Promise.resolve()
    },
    willAuthError({ context }) {
      const token = getToken()
      if (!token) {
        return true
      }
      const decodedJwt = JSON.parse(atob(token.split('.')[1]))
      const expirySeconds = decodedJwt.exp - Date.now() / 1000
      if (expirySeconds < 0) {
        log('⛔️ Token is expired. Request will fail.')
        return true
      }
      return false
    },
  }
})

export const UrqlProvider = ({ children }: { children: ReactNode }) => {
  const clientRef = useRef<Client>()

  const [activeOrganization] = useLocalStorage<string>('activeOrganization', '', {
    deserializer: (value) => value,
    serializer: (value) => value || '',
  })

  clientRef.current = new Client({
    url: '/api/graphql',
    exchanges: [cacheExchange, auth, fetchExchange],
    fetchOptions: {
      headers: {
        'X-Organization-Id': activeOrganization,
      },
    },
  })

  useEffect(() => {
    clientRef.current = new Client({
      url: '/api/graphql',
      exchanges: [cacheExchange, auth, fetchExchange],
      fetchOptions: {
        headers: {
          'X-Organization-Id': activeOrganization,
        },
      },
    })
  }, [activeOrganization])

  return <Provider value={clientRef.current}>{children}</Provider>
}
